import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { CONNECTIONS_QUERY_KEY, OAUTH_FLOW_ERRORS } from '../utils/consts';
import { takeOAuthFlowResult } from '../utils/oauthFlowResult';

type Handlers = {
  onConnected: (connectionId: string) => void;
  onError: (description: string) => void;
};

export const useOAuthFlowResult = ({ onConnected, onError }: Handlers) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const result = takeOAuthFlowResult();
    if (!result) {
      return;
    }
    if ('connectionId' in result) {
      queryClient.invalidateQueries({ queryKey: [CONNECTIONS_QUERY_KEY] });
      onConnected(result.connectionId);
    } else {
      onError(
        OAUTH_FLOW_ERRORS[result.error] ??
          'The connection could not be completed. Please try again.',
      );
    }
  }, [queryClient, onConnected, onError]);
};
